import { defineComponent as o, openBlock as n, createBlock as r, unref as a, withCtx as i, createElementVNode as f } from "vue";
import l from "../SfIconBase/SfIconBase.vue.mjs";
import { SfIconSize as m } from "@storefront-ui/shared";
const c = /* @__PURE__ */ o({
  __name: "SfIconUnfoldMore",
  props: {
    size: {
      type: String,
      default: m.base
    }
  },
  setup(t) {
    return (s, e) => (n(), r(a(l), {
      size: t.size,
      viewBox: "0 0 24 24",
      "data-testid": "unfold-more"
    }, {
      default: i(() => e[0] || (e[0] = [
        f("path", { d: "M8.225 8.325Q7.95 8.05 7.95 7.6t.275-.725L11.3 3.8q.15-.15.325-.213.175-.062.375-.062t.388.062a.7.7 0 0 1 .312.213l3.1 3.1q.274.274.262.712t-.287.713-.725.275-.725-.275L12 6 9.65 8.35q-.274.274-.712.263a1 1 0 0 1-.713-.288M12 20.575a.9.9 0 0 1-.375-.075 1.3 1.3 0 0 1-.325-.2l-3.075-3.075q-.275-.275-.275-.725t.275-.725.725-.275.725.275L12 18.1l2.35-2.35q.274-.274.712-.262t.713.287.275.725-.275.725L12.7 20.3a.9.9 0 0 1-.312.2q-.188.075-.388.075" }, null, -1)
      ])),
      _: 1
    }, 8, ["size"]));
  }
});
export {
  c as default
};
